export const SIDEBAR_VISIBILITY_OPTIONS = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'coupons', label: 'Coupons' },
  { id: 'ahri-data', label: 'AHRI Data' },
  { id: 'ahri-assistant', label: 'AHRI Assistant' },
  { id: 'ahri-search', label: 'AHRI Search' },
  { id: 'ai-visualizer', label: 'AI Visualizer' },
  { id: 'opensearch-config', label: 'OpenSearch Config' },
  { id: 'ahri-system-shop', label: 'AHRI System Shop' },
  { id: 'system-shop-events', label: 'System Shop Events' },
  { id: 'semantix-search', label: 'SemantiX Search' },
  { id: 'ai-visualize-admin', label: 'AI Visualize Admin' },
  { id: 'ai-reqpro', label: 'Ai ReqPro' },
  { id: 'documents', label: 'Documents' },
  { id: 'documents-v4', label: 'Documents v4' },
  { id: 'products', label: 'Products' },
  { id: 'configurable-products', label: 'Configurable Products' },
  { id: 'order-genie', label: 'OrderX' },
  { id: 'order-genie-v2', label: 'OrderX V2' },
  { id: 'purchase-program', label: 'Purchase Program' },
  { id: 'styles', label: 'Styles' },
  { id: 'webhook-consumer', label: 'Webhook Consumer' },
  { id: 'realtime-connections', label: 'Realtime Connections' },
  { id: 'data-quality', label: 'Data Quality' },
  { id: 'chat', label: 'Chat' },
  { id: 'settings', label: 'Settings' },
  { id: 'reports', label: 'Reports' },
  { id: 'cad-3d', label: 'CAD 3D' },
];

export const DASHBOARD_CARD_VISIBILITY_OPTIONS = [
  { id: 'ahri-data', label: 'AHRI Data' },
  { id: 'ahri-system-shop', label: 'AHRI System Shop' },
  { id: 'semantix-search', label: 'SemantiX Search' },
  { id: 'products', label: 'Products' },
  { id: 'data-quality', label: 'Data Quality' },
  { id: 'ai-virtual-tryout-room', label: 'AI Virtual Tryout Room' },
  { id: 'ai-documents', label: 'AI Documents' },
];
